import { getAssetLinkFromStorage } from 'api/Firebase/storage'
import { useEffect, useState } from 'react'
import { WizardOrderProduct } from '../types'

interface SmallProductItemProps {
  product: WizardOrderProduct
  currency: string
  nameClassName?: string
  priceClassName?: string
}

export const SmallProductItem = ({
  product,
  currency,
  nameClassName = 'text-gray-700 dark:text-gray-100',
  priceClassName = 'text-gray-500 dark:text-gray-400',
}: SmallProductItemProps) => {
  const [logoUrl, setLogoUrl] = useState('')
  const [loadingLogo, setLoadingLogo] = useState(() => Boolean(product.imageFile))

  useEffect(() => {
    if (!product.imageFile) {
      setLogoUrl('')
      setLoadingLogo(false)
      return
    }
    setLoadingLogo(true)
    getAssetLinkFromStorage(product.imageFile)
      .then(link => {
        setLogoUrl(link)
        setLoadingLogo(false)
      })
      .catch(() => {
        setLogoUrl('')
        setLoadingLogo(false)
      })
  }, [product.imageFile])

  return (
    <div className='flex mb-3' key={product.productId}>
      {(loadingLogo && (
        <div className='mr-4 mt-1 flex-shrink-0'>
          <div className='h-8 w-8 rounded-[3px] bg-gray-200 dark:bg-gray-700 animate-pulse' />
        </div>
      )) || (
        <div className='mr-4 mt-1 flex-shrink-0'>
          {logoUrl ? (
            <img className='inline-block h-8 w-8 rounded-[3px]' src={logoUrl} alt={product.name} />
          ) : (
            <svg
              className='h-8 w-8 border border-gray-300 bg-white text-gray-300'
              preserveAspectRatio='none'
              stroke='currentColor'
              fill='none'
              viewBox='0 0 200 200'
              aria-hidden='true'
            >
              <path
                vectorEffect='non-scaling-stroke'
                strokeWidth={1}
                d='M0 0l200 200M0 200L200 0'
              />
            </svg>
          )}
        </div>
      )}
      <div className='flex flex-col w-full'>
        <div className='flex items-start justify-between'>
          <h4 className={`text-sm font-semibold ${nameClassName}`}>{product.name}</h4>
        </div>

        <p className={`text-sm ${priceClassName}`}>
          {currency || '€'}
          {product.quantity * Number(product.price)}
        </p>
      </div>
    </div>
  )
}
